<template>
  <div
    class="z-10 fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-t md:hidden"
  >
    <div class="flex justify-around items-center py-2">
      <router-link
        to="/portal"
        class="flex flex-col items-center text-xs"
        :class="$route.path === '/portal' ? 'text-blue-600' : 'text-gray-500'"
      >
        <DashboardSvg class="w-6 h-6" />
        <span>Home</span>
      </router-link>

      <router-link
        to="/portal/transaction"
        class="flex flex-col items-center text-xs"
        :class="
          $route.path === '/portal/transaction'
            ? 'text-blue-600'
            : 'text-gray-500'
        "
      >
        <CalendarSvg class="w-6 h-6" />
        <span>Transaction</span>
      </router-link>

      <div
        class="flex flex-col items-center text-xs"
        @click="$emit('toggle-sidebar')"
      >
        <BurgerMenu class="w-6 h-6" />
        <span>Menu</span>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardSvg from "@/components/svgs/DashboardSvg.vue";
import CalendarSvg from "@/components/svgs/CalendarSvg.vue";
import CustomerSvg from "@/components/svgs/CustomerSvg.vue";
import BurgerMenu from "@/components/svgs/BurgerMenuSvg.vue";

export default {
  components: {
    DashboardSvg,
    CalendarSvg,
    CustomerSvg,
    BurgerMenu,
  },
};
</script>

<style scoped>
/* Optional: subtle top shadow */
.shadow-t {
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.05);
}
</style>
